import { render, staticRenderFns } from "./IsiEkspektasiPerilaku.vue?vue&type=template&id=d9dea4ba&scoped=true&lang=html&"
import script from "./IsiEkspektasiPerilaku.vue?vue&type=script&lang=js&"
export * from "./IsiEkspektasiPerilaku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9dea4ba",
  null
  
)

export default component.exports